import moment from 'moment';

import {
  TAllReportsParams,
  TAllReportsParamsQuery
} from '@/types/api-types/reports';

import { DATA_FORMAT_WITH_TIME } from '@/utils/constants';

const prepareCreated = (
  start: moment.Moment | undefined,
  end: moment.Moment | undefined
): string | null => {
  if (start && end) {
    return `${start.format(DATA_FORMAT_WITH_TIME)},${end.format(
      DATA_FORMAT_WITH_TIME
    )}`;
  } else if (start && !end) {
    return `${start.format(DATA_FORMAT_WITH_TIME)}`;
  } else if (!start && end) {
    return `,${end.format(DATA_FORMAT_WITH_TIME)}`;
  } else {
    return null;
  }
};

const prepareFetchAllRepotsParams = ({
  createdStart,
  createdEnd,
  descOrdering,
  ordering,
  search,
  page,
  pageSize,
  category,
  subcategory,
  status,
  confirmed,
  type
}: TAllReportsParams['data']): TAllReportsParamsQuery => {
  const params = {
    ordering: ordering
      ? `${Boolean(descOrdering) ? '-' : ''}${ordering}`
      : null,
    search,
    page,
    page_size: pageSize,
    category,
    subcategory,
    status,
    confirmed,
    type,
    created: prepareCreated(createdStart, createdEnd)
  };

  if (params.confirmed !== 0 && params.confirmed !== 1) {
    // eslint-disable-next-line
    for (const [key, value] of Object.entries(params as Record<string, any>)) {
      if (key === 'subcategory' && Array.isArray(value) && !value.length) {
        continue;
      }

      if (!value) {
        delete (params as Record<string, any>)[key]; // eslint-disable-line
      }
    }
  }

  return params;
};

export default prepareFetchAllRepotsParams;
